var Mustache = require("mustache")

export default class IcStatusDoc {
    constructor() {
        //eslint-disable-next-line
        this.json = `
        {"pageSize":"LETTER","pageMargins":[0,0,0,0],"background":[{"image":"background","width":615}],"content":[{"text":"{{{name}}}","absolutePosition":{"x":50,"y":207}},{"text":"{{{company}}}","absolutePosition":{"x":220,"y":207}},{"text":"{{{job}}}","absolutePosition":{"x":405,"y":207}},{"text":"{{{address}}}","absolutePosition":{"x":50,"y":231}},{"text":"{{{exchange}}}","absolutePosition":{"x":459,"y":231}},{"text":"{{{phone}}}","absolutePosition":{"x":489,"y":231}},{"text":"{{{email}}}","absolutePosition":{"x":50,"y":254}},{"text":"{{{ssn}}}","absolutePosition":{"x":220,"y":254}},{"text":"{{{resYes}}}","absolutePosition":{"x":153,"y":276}},{"text":"{{{resNo}}}","absolutePosition":{"x":189,"y":276}},{"text":"{{{resState}}}","absolutePosition":{"x":220,"y":278}},{"text":"{{{isIC}}}","absolutePosition":{"x":37,"y":328}},{"text":"{{{isSP}}}","absolutePosition":{"x":37,"y":347}},{"text":"{{{isPART}}}","absolutePosition":{"x":37,"y":394}},{"text":"{{{isLLC}}}","absolutePosition":{"x":37,"y":441}},{"text":"{{{empsYes}}}","absolutePosition":{"x":46,"y":498}},{"text":"{{{empsNo}}}","absolutePosition":{"x":78,"y":498}},{"text":"{{{wcYes}}}","absolutePosition":{"x":231,"y":498}},{"text":"{{{wcNo}}}","absolutePosition":{"x":263,"y":498}},{"text":"{{{spName}}}","absolutePosition":{"x":50,"y":372}},{"text":"{{{spSSN}}}","absolutePosition":{"x":410,"y":372}},{"text":"{{{partName}}}","absolutePosition":{"x":50,"y":419}},{"text":"{{{partSSN}}}","absolutePosition":{"x":410,"y":419}},{"text":"{{{llcName}}}","absolutePosition":{"x":50,"y":467}},{"text":"{{{llcSSN}}}","absolutePosition":{"x":410,"y":467}},{"text":"{{{date}}}","absolutePosition":{"x":459,"y":526}}],"defaultStyle":{"fontSize":10},"images":{"background":"{{{background}}}"}}        `

        /*
        this.formatted = `
{
  "pageSize": "LETTER",
  "pageMargins": [
    0,
    0,
    0,
    0
  ],
  "background": [
    {
      "image": "background",
      "width": 615
    }
  ],
  "content": [
    {
      "text": "{{{name}}}",
      "absolutePosition": {
        "x": 50,
        "y": 207
      }
    },
    {
      "text": "{{{company}}}",
      "absolutePosition": {
        "x": 220,
        "y": 207
      }
    },
    {
      "text": "{{{job}}}",
      "absolutePosition": {
        "x": 405,
        "y": 207
      }
    },
    {
      "text": "{{{address}}}",
      "absolutePosition": {
        "x": 50,
        "y": 231
      }
    },
    {
      "text": "{{{exchange}}}",
      "absolutePosition": {
        "x": 459,
        "y": 231
      }
    },
    {
      "text": "{{{phone}}}",
      "absolutePosition": {
        "x": 489,
        "y": 231
      }
    },
    {
      "text": "{{{email}}}",
      "absolutePosition": {
        "x": 50,
        "y": 254
      }
    },
    {
      "text": "{{{ssn}}}",
      "absolutePosition": {
        "x": 220,
        "y": 254
      }
    },
    {
      "text": "{{{resYes}}}",
      "absolutePosition": {
        "x": 153,
        "y": 276
      }
    },
    {
      "text": "{{{resNo}}}",
      "absolutePosition": {
        "x": 189,
        "y": 276
      }
    },
    {
      "text": "{{{resState}}}",
      "absolutePosition": {
        "x": 220,
        "y": 278
      }
    },
    {
      "text": "{{{isIC}}}",
      "absolutePosition": {
        "x": 37,
        "y": 328
      }
    },
    {
      "text": "{{{isSP}}}",
      "absolutePosition": {
        "x": 37,
        "y": 347
      }
    },
    {
      "text": "{{{isPART}}}",
      "absolutePosition": {
        "x": 37,
        "y": 394
      }
    },
    {
      "text": "{{{isLLC}}}",
      "absolutePosition": {
        "x": 37,
        "y": 441
      }
    },
    {
      "text": "{{{empsYes}}}",
      "absolutePosition": {
        "x": 46,
        "y": 498
      }
    },
    {
      "text": "{{{empsNo}}}",
      "absolutePosition": {
        "x": 78,
        "y": 498
      }
    },
    {
      "text": "{{{wcYes}}}",
      "absolutePosition": {
        "x": 231,
        "y": 498
      }
    },
    {
      "text": "{{{wcNo}}}",
      "absolutePosition": {
        "x": 263,
        "y": 498
      }
    },
    {
      "text": "{{{spName}}}",
      "absolutePosition": {
        "x": 50,
        "y": 372
      }
    },
    {
      "text": "{{{spSSN}}}",
      "absolutePosition": {
        "x": 410,
        "y": 372
      }
    },
    {
      "text": "{{{partName}}}",
      "absolutePosition": {
        "x": 50,
        "y": 419
      }
    },
    {
      "text": "{{{partSSN}}}",
      "absolutePosition": {
        "x": 410,
        "y": 419
      }
    },
    {
      "text": "{{{llcName}}}",
      "absolutePosition": {
        "x": 50,
        "y": 467
      }
    },
    {
      "text": "{{{llcSSN}}}",
      "absolutePosition": {
        "x": 410,
        "y": 467
      }
    },
    {
      "text": "{{{date}}}",
      "absolutePosition": {
        "x": 459,
        "y": 526
      }
    }
  ],
  "defaultStyle": {
    "fontSize": 10
  },
  "images": {
    "background": "{{{background}}}"
  }
}
`        
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
